import { render, staticRenderFns } from "./AiaContainer.vue?vue&type=template&id=4b9c8a3e&scoped=true"
import script from "./AiaContainer.vue?vue&type=script&lang=js"
export * from "./AiaContainer.vue?vue&type=script&lang=js"
import style0 from "./AiaContainer.vue?vue&type=style&index=0&id=4b9c8a3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9c8a3e",
  null
  
)

export default component.exports